import React from "react";
import Ajax from "../../ajax/Ajax";
import loader from "../../images/loader.gif";
import { Loading } from "../../App";
import { domain } from "../../ajax/Ajax";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet/es/Helmet";
import queryString from "query-string";
import logo from "../../images/logo.png";
import { PayPalButton } from "react-paypal-button-v2";

class OrderProduct extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pid: null,
      product: null,
      paymentReceived: false,
      orderSubmitted: false,
      qty: 1,
      clientDetails: JSON.parse(localStorage.getItem("clientDetails"))
        ? JSON.parse(localStorage.getItem("clientDetails"))
        : {},
    };

    this.submitOrder = this.submitOrder.bind(this);
  }

  async submitOrder(data, details, total) {
    console.log(data, details);
    let order = {
      orders: [
        {
          shop: {
            products: [
              {
                product: this.state.product,
                qty: this.state.qty,
              },
            ],
            name: this.state.product.shop.name,
            shop_id: this.state.product.shop.id,
            total: total,
          },
          client: {
            data: data,
            details: details,
          },
        },
      ],
    };

    let response = await Ajax.postData(
      domain + "/en/api/shop/v1/order/",
      order
    );
    if (response) {
      this.setState({
        orderSubmitted: true,
      });

      setTimeout(function () {
        window.location.assign("/market/home/");
      }, 5000);
    }
  }

  async componentDidMount() {
    let params = queryString.parse(this.props.location.search);
    let urlState = this.props.location.state;
    console.log(params, urlState);
    if (urlState) {
    }
    await this.setState({
      pid: params.pid,
      product: urlState.product,
    });
  }

  render() {
    let product = this.state.product;
    let total = 0;
    if (product) {
      total = (this.state.product.item.price * this.state.qty * 0.0017).toFixed(
        2
      );
    }
    console.log(total, "the total");
    return (
      <div className="">
        <div
          id="order-product-modal"
          className="modal is-active animated zoomIn"
        >
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Place Order</p>
              <span className="m-2">
                <img
                  className="is-hidden"
                  id="submit-order-loader"
                  src={loader}
                  alt="processing..."
                />
              </span>
              <div>
                {this.state.product ? (
                  <span className="mr-2 is-size-5">
                    <strong>
                      {product.shop.currency}{" "}
                      {(
                        this.state.product.item.price * this.state.qty
                      ).toLocaleString()}
                    </strong>
                  </span>
                ) : (
                  <span></span>
                )}

                <Link
                  to={
                    this.props.shop
                      ? `/shop-at/${this.props.shop.name.replace(
                          /\s+/g,
                          "-"
                        )}/${this.props.shop.id}/`
                      : "/market/"
                  }
                >
                  <button className="delete" aria-label="close"></button>
                </Link>
              </div>
            </header>
            <section className="modal-card-body">
              {this.state.product ? (
                <div className="card is-shadowless">
                  <Helmet>
                    <link rel="icon" href={logo} />
                    <title>Order | {product.item.name}</title>
                  </Helmet>

                  {this.state.paymentReceived ? (
                    <div>
                      {this.state.orderSubmitted ? (
                        <div className="animated fadeIn">
                          <p className="title has-text-centered">
                            Order Submitted!
                          </p>
                          <div className="message is-success">
                            <div className="message-body is-size-6">
                              <p>
                                <span className="zmdi zmdi-check-circle mr-2"></span>
                              </p>
                              <div className="has-text-centered">
                                <p className="mt-2">
                                  Your Order has been submitted. You will be
                                  notified after shipping
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="message is-info animated fadeIn">
                          <div className="message-body is-size-5">
                            <p>
                              <span className="zmdi zmdi-check-circle mr-2"></span>
                            </p>
                            <div className="has-text-centered">
                              <p>Payment Received!</p>
                              <div className="mt-2">
                                <Loading />
                              </div>
                              <p className="mt-2">Sending...</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      <div className="card-content">
                        <div>
                          <p>Ordering from:</p>
                          <p>
                            <strong>{product.shop.name}</strong>
                          </p>
                          <p>
                            {product.shop.distance ? (
                              <span>
                                ~
                                {Number(product.shop.distance).toLocaleString()}
                                m from you{" "}
                              </span>
                            ) : (
                              <span>Unknown distance from you</span>
                            )}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between pt-2">
                          <div className="">
                            <strong>{product.item.name}</strong>
                          </div>
                          <div className="has-text-success">
                            {product.shop.currency}{" "}
                            {product.item.price.toLocaleString()}
                          </div>
                        </div>
                        <div>
                          <div className="has-text-info">
                            {product.item.stock} {product.item.unit} Available
                          </div>
                        </div>

                        <hr />
                        <div>
                          <form action="#" onSubmit={this.submitOrder}>
                            <div className="field">
                              <label htmlFor="qty">Qty</label>
                              <input
                                onChange={(event) => {
                                  this.setState({ qty: event.target.value });
                                }}
                                value={this.state.qty}
                                id="order_qty"
                                name="qty"
                                type="number"
                                required
                                className="input"
                              />
                              <input
                                id="order_sub_branch"
                                type="text"
                                name="sub_branch"
                                className="is-hidden"
                                defaultValue={product.shop.sub_branch}
                              />
                              <input
                                id="order_product_id"
                                type="text"
                                name="product_id"
                                className="is-hidden"
                                defaultValue={product.item.id}
                              />
                            </div>

                            {this.state.product ? (
                              <div>
                                <PayPalButton
                                  amount={total}
                                  // shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
                                  onSuccess={(details, data) => {
                                    console.log(data, "success", details);

                                    this.setState({
                                      paymentReceived: true,
                                    });

                                    // OPTIONAL: Call your server to save the transaction
                                    this.submitOrder(data, details, total);
                                  }}
                                  onCancel={() => {
                                    console.log("operation canceled");
                                  }}
                                  onError={() => {
                                    console.log("error occured");
                                  }}
                                  options={{
                                    clientId:
                                      "AbtjGhqNfX3CTkF5ZhoD8BcQrMXu4yIa2lBtekBb7H-2UuvsSoQVeCKm41x6LwqdeD-EI5bKpS3w1SQ6",
                                  }}
                                />
                              </div>
                            ) : (
                              <div></div>
                            )}

                            <div className="is-hidden">
                              <button
                                id="submit_order_btn"
                                type="submit"
                                className="button"
                              ></button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <Loading />
                </div>
              )}
            </section>
            <footer className="modal-card-foot d-flex justify-content-between is-hidden">
              <button className="button">
                <span className="zmdi zmdi-shopping-card-add mr-1"></span>
                Add to Cart
              </button>
              <button onClick={this.placeOrder} className="button is-success">
                <span className="zmdi zmdi-money mr-1"></span>
                Place Order
              </button>
            </footer>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderProduct;
